import { TFunction } from "@impero-com/common/utils/i18n";
import { TimeToDueDateFilter } from "@impero-com/ui/domain";

const HOUR = 60 * 60 * 1000;
const DAY = 24 * HOUR;
const UNIT_DURATION = { hours: HOUR, days: DAY, months: 30 * DAY };
const UNIT_LABEL = {
    hours: "ControlActivitiesList_TimeToDueDate_Hours",
    days: "ControlActivitiesList_TimeToDueDate_Days",
    months: "ControlActivitiesList_TimeToDueDate_Months",
} as const;

export function timeToDueDate(
    dueDate: string,
    completed: boolean,
    now: number
): number | null {
    return completed ? null : Date.parse(dueDate) - now;
}

export function roundedDueDateDuration(
    duration: number,
    unit: "hours" | "days" | "months"
): number {
    return Math.floor(Math.abs(duration) / UNIT_DURATION[unit]);
}

function automaticUnit(duration: number): keyof typeof UNIT_DURATION {
    if (Math.abs(duration) >= UNIT_DURATION.months) {
        return "months";
    }
    return Math.abs(duration) >= DAY ? "days" : "hours";
}

export function formatTimeToDueDate(duration: number, t: TFunction): string {
    const displayUnit = automaticUnit(duration);
    const count = roundedDueDateDuration(duration, displayUnit);
    const text = t(UNIT_LABEL[displayUnit], { count });
    return duration < 0
        ? t("ControlActivitiesList_TimeToDueDate_Overdue", { duration: text })
        : text;
}

export function matchesTimeToDueDate(
    duration: number | null,
    filter: TimeToDueDateFilter | null
): boolean {
    if (!filter) {
        return true;
    }
    if (
        duration === null ||
        duration < 0 !== (filter.direction === "overdue")
    ) {
        return false;
    }
    const count = roundedDueDateDuration(duration, filter.unit);
    const comparison = filter.comparison;
    switch (comparison.type) {
        case "atLeast":
            return count >= comparison.value;
        case "atMost":
            return count <= comparison.value;
    }
}
